<template>
    <div>
        <div v-if="rollovers.length">
            <h2>Rollover from {{ period_name }}</h2>
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>Budget</th>
                        <th>Spend</th>
                        <th>Rollover in USD</th>
                        <th style="width: 200px;"></th>
                    </tr>
                    </thead>
                    <tbody>
                        <budgets-rollover-line :rollover="rollover" v-for="rollover in rollovers" :key="rollover.id" @updated="update"></budgets-rollover-line>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import BudgetsRolloverLine from "./budgets-rollover-line";

export default {
    components: {BudgetsRolloverLine},
    props: [
        'employer_id'
    ],
    data() {
        return {
            'rollovers': [],
            'period_name': ''
        };
    },
    methods: {
        refresh() {
            return axios.get(url(`admin/budget-rollover/list`), {
                'params': { employer_id: this.employer_id }
            }).then((response) => {
                this.rollovers = response.data.rows;
                this.period_name = response.data.period_name;
            });
        },
        update() {
            this.$emit('updated');
            this.refresh();
        }
    },
    mounted() {
        this.refresh();
    },
}
</script>
